import {
    identifyIntercom,
    intercomUpdate,
    loadIntercom,
} from './analytics-base/analytics';
import {
    Actions,
    Components,
    Features,
    Teams,
} from './analytics-enums/heap-atributes';
import { HeapDataAttribute, IntercomUpdateKeyType } from './types';

const initIntercom = () => {
    if (typeof window === 'undefined') return;

    loadIntercom();
    identifyIntercom();
};

const updateIntercom = (params: {
    [key in IntercomUpdateKeyType]?: any;
}) => {
    if (typeof window === 'undefined') return;
    const _window = window as Window &
        typeof globalThis & { Intercom: () => {} };

    if (!_window.Intercom) {
        initIntercom();
    }

    intercomUpdate(params);
};

const getHeapDataAttribute = (params: {
    team: Teams;
    feature: Features;
    component: Components;
    action: Actions;
}): HeapDataAttribute => {
    const { team, feature, component, action } = params;

    return `${team}-${feature}-${component}-${action}`;
};

export { updateIntercom, getHeapDataAttribute };
